import { ScamTypeAssessment } from '../types'

export const scamAssessments: ScamTypeAssessment[] = [
  {
    scamType: 'social-engineering',
    title: {
      en: 'Social Engineering Risk Assessment',
      id: 'Penilaian Risiko Rekayasa Sosial',
    },
    description: {
      en: 'Answer these questions to check if you are being targeted by a social engineering attack.',
      id: 'Jawab pertanyaan ini untuk memeriksa apakah Anda menjadi target serangan rekayasa sosial.',
    },
    questions: [
      {
        id: 'impersonation',
        text: {
          en: 'Is the person claiming to be an official (police, bank officer, tax office, government agency) or someone you know but acting strangely or unusually?',
          id: 'Apakah orang tersebut mengaku sebagai pejabat (polisi, petugas bank, kantor pajak, instansi pemerintah) atau seseorang yang Anda kenal tetapi bertindak aneh atau tidak biasa?',
        },
        weight: 2,
      },
      {
        id: 'urgency',
        text: {
          en: 'Are they creating a strong sense of urgency or fear? For example: "Your account will be blocked in 24 hours", "You will be arrested today", "Act now or lose everything"?',
          id: 'Apakah mereka menciptakan rasa urgensi atau ketakutan yang kuat? Misalnya: "Akun Anda akan diblokir dalam 24 jam", "Anda akan ditangkap hari ini", "Bertindak sekarang atau kehilangan segalanya"?',
        },
        weight: 3,
      },
      {
        id: 'secrecy',
        text: {
          en: 'Did they specifically ask you to keep this conversation secret from your family, friends, or bank staff? Did they say things like "Don\'t tell anyone about this call"?',
          id: 'Apakah mereka secara khusus meminta Anda merahasiakan percakapan ini dari keluarga, teman, atau staf bank? Apakah mereka mengatakan hal seperti "Jangan beritahu siapa pun tentang panggilan ini"?',
        },
        weight: 3,
      },
      {
        id: 'unusual_contact',
        text: {
          en: 'Did they contact you unexpectedly via phone call, WhatsApp, Telegram, or social media without any prior relationship or context?',
          id: 'Apakah mereka menghubungi Anda secara tiba-tiba melalui telepon, WhatsApp, Telegram, atau media sosial tanpa hubungan atau konteks sebelumnya?',
        },
        weight: 1,
      },
      {
        id: 'info_request',
        text: {
          en: 'Are they asking for sensitive information like passwords, PINs, OTPs (One-Time Passwords), CVV codes, or full credit card numbers?',
          id: 'Apakah mereka meminta informasi sensitif seperti kata sandi, PIN, OTP (One-Time Password), kode CVV, atau nomor kartu kredit lengkap?',
        },
        weight: 3,
      },
      {
        id: 'money_request',
        text: {
          en: 'Are they asking you to transfer money to a "safe account", "verification account", or asking you to verify your funds by making a transfer?',
          id: 'Apakah mereka meminta Anda mentransfer uang ke "rekening aman", "rekening verifikasi", atau meminta Anda memverifikasi dana dengan melakukan transfer?',
        },
        weight: 3,
      },
      {
        id: 'remote_access',
        text: {
          en: 'Did they ask you to install any app (like AnyDesk, TeamViewer, or unknown apps) or share your screen with them?',
          id: 'Apakah mereka meminta Anda menginstal aplikasi apa pun (seperti AnyDesk, TeamViewer, atau aplikasi tidak dikenal) atau membagikan layar Anda dengan mereka?',
        },
        weight: 3,
      },
      {
        id: 'caller_id_spoofing',
        text: {
          en: 'Did the caller ID show an official-looking number (like a bank hotline or police number), but the conversation feels suspicious?',
          id: 'Apakah ID penelepon menunjukkan nomor yang terlihat resmi (seperti hotline bank atau nomor polisi), tetapi percakapannya terasa mencurigakan?',
        },
        weight: 2,
      },
      {
        id: 'emotional_manipulation',
        text: {
          en: "Are they using emotional manipulation tactics like making you feel guilty, scared, or responsible for a problem you didn't know existed?",
          id: 'Apakah mereka menggunakan taktik manipulasi emosional seperti membuat Anda merasa bersalah, takut, atau bertanggung jawab atas masalah yang tidak Anda ketahui sebelumnya?',
        },
        weight: 2,
      },
      {
        id: 'verification_refusal',
        text: {
          en: 'When you asked to verify their identity or call back through official channels, did they refuse, make excuses, or pressure you not to?',
          id: 'Ketika Anda meminta untuk memverifikasi identitas mereka atau menelepon balik melalui saluran resmi, apakah mereka menolak, membuat alasan, atau menekan Anda untuk tidak melakukannya?',
        },
        weight: 2,
      },
    ],
  },
  {
    scamType: 'investment-crypto',
    title: {
      en: 'Investment & Crypto Scam Check',
      id: 'Cek Penipuan Investasi & Kripto',
    },
    description: {
      en: "Assess the risk of an investment opportunity you've encountered.",
      id: 'Nilai risiko peluang investasi yang Anda temui.',
    },
    questions: [
      {
        id: 'guaranteed_returns',
        text: {
          en: 'Does the investment promise guaranteed high returns (like 10-50% monthly) with little or no risk? Remember: legitimate investments always carry risk.',
          id: 'Apakah investasi menjanjikan keuntungan tinggi yang dijamin (seperti 10-50% per bulan) dengan risiko kecil atau tanpa risiko? Ingat: investasi yang sah selalu memiliki risiko.',
        },
        weight: 3,
      },
      {
        id: 'pressure',
        text: {
          en: 'Are you being pressured to invest quickly with phrases like "limited time offer", "only 5 spots left", or "you\'ll miss out if you don\'t act now"?',
          id: 'Apakah Anda didesak untuk berinvestasi cepat dengan frasa seperti "penawaran terbatas", "hanya tersisa 5 slot", atau "Anda akan ketinggalan jika tidak bertindak sekarang"?',
        },
        weight: 2,
      },
      {
        id: 'social_media',
        text: {
          en: 'Did you find this opportunity through social media ads, a dating app, or someone who contacted you out of the blue claiming to be a successful trader?',
          id: 'Apakah Anda menemukan peluang ini melalui iklan media sosial, aplikasi kencan, atau seseorang yang menghubungi Anda secara tiba-tiba yang mengaku sebagai trader sukses?',
        },
        weight: 2,
      },
      {
        id: 'unregulated',
        text: {
          en: 'Is the platform unregulated or not registered with your local financial authority (like OJK in Indonesia, SEC, or MAS)? Can you verify their license?',
          id: 'Apakah platform tidak diatur atau tidak terdaftar di otoritas keuangan setempat (seperti OJK di Indonesia, SEC, atau MAS)? Bisakah Anda memverifikasi lisensi mereka?',
        },
        weight: 3,
      },
      {
        id: 'withdrawal_fees',
        text: {
          en: 'Are you being asked to pay "taxes", "fees", "insurance", or "verification charges" before you can withdraw your profits?',
          id: 'Apakah Anda diminta membayar "pajak", "biaya", "asuransi", atau "biaya verifikasi" sebelum dapat menarik keuntungan Anda?',
        },
        weight: 3,
      },
      {
        id: 'mentor',
        text: {
          en: 'Is a "mentor", "teacher", "analyst", or "account manager" guiding you through every step, telling you exactly when and how much to invest?',
          id: 'Apakah seorang "mentor", "guru", "analis", atau "manajer akun" membimbing Anda melalui setiap langkah, memberi tahu Anda kapan dan berapa banyak yang harus diinvestasikan?',
        },
        weight: 2,
      },
      {
        id: 'celebrity_endorsement',
        text: {
          en: 'Does the platform use celebrity endorsements, fake news articles, or testimonials from "successful investors" that seem too good to be true?',
          id: 'Apakah platform menggunakan dukungan selebriti, artikel berita palsu, atau testimoni dari "investor sukses" yang tampaknya terlalu bagus untuk menjadi kenyataan?',
        },
        weight: 2,
      },
      {
        id: 'complex_strategy',
        text: {
          en: 'Do they use complex jargon like "AI trading", "arbitrage algorithm", "blockchain mining pool" without clear explanation of how your money is actually invested?',
          id: 'Apakah mereka menggunakan jargon kompleks seperti "AI trading", "algoritma arbitrase", "pool mining blockchain" tanpa penjelasan jelas tentang bagaimana uang Anda sebenarnya diinvestasikan?',
        },
        weight: 2,
      },
      {
        id: 'initial_profits',
        text: {
          en: 'Did you receive small initial profits easily, but now they\'re asking you to invest more to "unlock" bigger returns or reach a "higher tier"?',
          id: 'Apakah Anda menerima keuntungan awal kecil dengan mudah, tetapi sekarang mereka meminta Anda untuk berinvestasi lebih banyak untuk "membuka" keuntungan lebih besar atau mencapai "tingkat lebih tinggi"?',
        },
        weight: 3,
      },
      {
        id: 'recruitment',
        text: {
          en: 'Are they encouraging you to recruit friends and family with promises of bonuses or commissions? This is a sign of a pyramid/Ponzi scheme.',
          id: 'Apakah mereka mendorong Anda untuk merekrut teman dan keluarga dengan janji bonus atau komisi? Ini adalah tanda skema piramida/Ponzi.',
        },
        weight: 3,
      },
      {
        id: 'crypto_wallet',
        text: {
          en: 'Are they asking you to send cryptocurrency to a wallet address they control, or to connect your wallet to an unknown website?',
          id: 'Apakah mereka meminta Anda mengirim cryptocurrency ke alamat wallet yang mereka kontrol, atau menghubungkan wallet Anda ke situs web yang tidak dikenal?',
        },
        weight: 3,
      },
    ],
  },
  {
    scamType: 'romance-scam',
    title: {
      en: 'Romance Scam Assessment',
      id: 'Penilaian Penipuan Asmara',
    },
    description: {
      en: 'Check if your online relationship might be a romance scam.',
      id: 'Periksa apakah hubungan online Anda mungkin merupakan penipuan asmara.',
    },
    questions: [
      {
        id: 'quick_love',
        text: {
          en: 'Did the person profess their love, call you "dear", "honey", or talk about marriage very quickly (within days or weeks) after meeting online?',
          id: 'Apakah orang tersebut menyatakan cinta, memanggil Anda "sayang", "honey", atau berbicara tentang pernikahan dengan sangat cepat (dalam hitungan hari atau minggu) setelah bertemu online?',
        },
        weight: 2,
      },
      {
        id: 'never_met',
        text: {
          en: 'Have they consistently made excuses to avoid meeting in person or having video calls? Do they always have "technical problems" with their camera?',
          id: 'Apakah mereka secara konsisten membuat alasan untuk menghindari pertemuan langsung atau panggilan video? Apakah mereka selalu memiliki "masalah teknis" dengan kamera mereka?',
        },
        weight: 3,
      },
      {
        id: 'money_request',
        text: {
          en: 'Have they asked for money for emergencies (medical bills, stuck at airport, business problems), travel to meet you, or investment opportunities?',
          id: 'Apakah mereka meminta uang untuk keadaan darurat (tagihan medis, terjebak di bandara, masalah bisnis), perjalanan untuk bertemu Anda, atau peluang investasi?',
        },
        weight: 3,
      },
      {
        id: 'overseas',
        text: {
          en: 'Do they claim to be working overseas in a profession that makes them hard to reach (military deployment, oil rig, international doctor, UN worker)?',
          id: 'Apakah mereka mengaku bekerja di luar negeri dalam profesi yang membuat mereka sulit dihubungi (penugasan militer, kilang minyak, dokter internasional, pekerja PBB)?',
        },
        weight: 2,
      },
      {
        id: 'sob_story',
        text: {
          en: 'Do they share tragic stories (dead spouse, sick child, business failure) to gain your sympathy and emotional connection?',
          id: 'Apakah mereka berbagi cerita tragis (pasangan meninggal, anak sakit, kegagalan bisnis) untuk mendapatkan simpati dan koneksi emosional Anda?',
        },
        weight: 2,
      },
      {
        id: 'move_platform',
        text: {
          en: "Did they quickly try to move the conversation off the dating app to WhatsApp, Telegram, or email where there's less oversight?",
          id: 'Apakah mereka dengan cepat mencoba memindahkan percakapan dari aplikasi kencan ke WhatsApp, Telegram, atau email di mana ada lebih sedikit pengawasan?',
        },
        weight: 1,
      },
      {
        id: 'perfect_profile',
        text: {
          en: 'Does their profile seem too perfect? Very attractive photos, successful career, similar interests to yours, and they seem to be your "ideal partner"?',
          id: 'Apakah profil mereka tampak terlalu sempurna? Foto sangat menarik, karir sukses, minat yang sama dengan Anda, dan mereka tampak menjadi "pasangan ideal" Anda?',
        },
        weight: 2,
      },
      {
        id: 'inconsistent_stories',
        text: {
          en: "Have you noticed inconsistencies in their stories? Details that don't add up, changing facts, or things that contradict what they said before?",
          id: 'Apakah Anda memperhatikan ketidakkonsistenan dalam cerita mereka? Detail yang tidak cocok, fakta yang berubah, atau hal-hal yang bertentangan dengan apa yang mereka katakan sebelumnya?',
        },
        weight: 2,
      },
      {
        id: 'gift_cards',
        text: {
          en: 'Have they asked you to send money via gift cards (iTunes, Google Play, Steam), cryptocurrency, or wire transfer instead of normal bank transfer?',
          id: 'Apakah mereka meminta Anda mengirim uang melalui kartu hadiah (iTunes, Google Play, Steam), cryptocurrency, atau wire transfer alih-alih transfer bank normal?',
        },
        weight: 3,
      },
      {
        id: 'isolation',
        text: {
          en: 'Do they discourage you from telling friends or family about your relationship, or get upset when you mention discussing them with others?',
          id: 'Apakah mereka mencegah Anda memberitahu teman atau keluarga tentang hubungan Anda, atau marah ketika Anda menyebutkan membahas mereka dengan orang lain?',
        },
        weight: 2,
      },
      {
        id: 'reverse_image',
        text: {
          en: 'Have you tried reverse image searching their photos? Did you find the same photos on other profiles or stock photo websites?',
          id: 'Apakah Anda sudah mencoba reverse image search foto mereka? Apakah Anda menemukan foto yang sama di profil lain atau situs foto stok?',
        },
        weight: 2,
      },
    ],
  },
  {
    scamType: 'phishing-account-takeover',
    title: {
      en: 'Phishing & Account Takeover Risk Check',
      id: 'Cek Risiko Phishing & Pengambilalihan Akun',
    },
    description: {
      en: 'Determine if a message, email, or website is a phishing attempt.',
      id: 'Tentukan apakah pesan, email, atau situs web adalah upaya phishing.',
    },
    questions: [
      {
        id: 'suspicious_link',
        text: {
          en: 'Does the message contain a link that looks strange, misspelled (like "amaz0n.com" or "bank-secure-login.com"), or uses a URL shortener?',
          id: 'Apakah pesan berisi tautan yang terlihat aneh, salah eja (seperti "amaz0n.com" atau "bank-secure-login.com"), atau menggunakan pemendek URL?',
        },
        weight: 3,
      },
      {
        id: 'urgent_action',
        text: {
          en: 'Does the message demand immediate action with threats like "Your account will be suspended", "Unauthorized login detected", or "Verify now or lose access"?',
          id: 'Apakah pesan menuntut tindakan segera dengan ancaman seperti "Akun Anda akan ditangguhkan", "Login tidak sah terdeteksi", atau "Verifikasi sekarang atau kehilangan akses"?',
        },
        weight: 2,
      },
      {
        id: 'otp_request',
        text: {
          en: "Does the link or message ask you to enter your password, OTP, PIN, or security questions on a page that's not the official website/app?",
          id: 'Apakah tautan atau pesan meminta Anda memasukkan kata sandi, OTP, PIN, atau pertanyaan keamanan di halaman yang bukan situs web/aplikasi resmi?',
        },
        weight: 3,
      },
      {
        id: 'unknown_sender',
        text: {
          en: 'Is the sender address slightly different from the official one? For example: "support@bank-security.com" instead of "@bank.com", or using free email like Gmail for official communication?',
          id: 'Apakah alamat pengirim sedikit berbeda dari yang resmi? Misalnya: "support@bank-security.com" bukan "@bank.com", atau menggunakan email gratis seperti Gmail untuk komunikasi resmi?',
        },
        weight: 2,
      },
      {
        id: 'generic_greeting',
        text: {
          en: 'Does the message use a generic greeting like "Dear Customer", "Dear User", or "Dear Sir/Madam" instead of your actual name?',
          id: 'Apakah pesan menggunakan salam umum seperti "Pelanggan Yth", "Pengguna Yth", atau "Bapak/Ibu Yth" bukan nama Anda yang sebenarnya?',
        },
        weight: 1,
      },
      {
        id: 'errors',
        text: {
          en: 'Are there spelling mistakes, grammar errors, or awkward phrasing in the message that seems unprofessional for an official communication?',
          id: 'Apakah ada kesalahan ejaan, kesalahan tata bahasa, atau frasa yang canggung dalam pesan yang tampak tidak profesional untuk komunikasi resmi?',
        },
        weight: 1,
      },
      {
        id: 'attachment',
        text: {
          en: "Does the email contain an unexpected attachment (like .exe, .zip, .doc with macros) that you're asked to download and open?",
          id: 'Apakah email berisi lampiran yang tidak terduga (seperti .exe, .zip, .doc dengan macro) yang diminta untuk Anda unduh dan buka?',
        },
        weight: 2,
      },
      {
        id: 'prize_notification',
        text: {
          en: "Does the message claim you've won a prize, lottery, or giveaway that you never entered, and asks you to click a link to claim it?",
          id: 'Apakah pesan mengklaim Anda memenangkan hadiah, lotere, atau giveaway yang tidak pernah Anda ikuti, dan meminta Anda mengklik tautan untuk mengklaimnya?',
        },
        weight: 2,
      },
      {
        id: 'ssl_certificate',
        text: {
          en: 'If you clicked the link, does the website show a security warning, have no padlock icon, or the URL starts with "http://" instead of "https://"?',
          id: 'Jika Anda mengklik tautan, apakah situs web menunjukkan peringatan keamanan, tidak memiliki ikon gembok, atau URL dimulai dengan "http://" bukan "https://"?',
        },
        weight: 2,
      },
      {
        id: 'unsolicited_call',
        text: {
          en: 'Did you receive an unexpected call or message claiming to be from tech support (Microsoft, Apple, your ISP) saying your device is infected or compromised?',
          id: 'Apakah Anda menerima panggilan atau pesan tak terduga yang mengaku dari dukungan teknis (Microsoft, Apple, ISP Anda) yang mengatakan perangkat Anda terinfeksi atau disusupi?',
        },
        weight: 2,
      },
    ],
  },
  {
    scamType: 'marketplace-payment',
    title: {
      en: 'Marketplace & Online Shopping Scam Check',
      id: 'Cek Penipuan Marketplace & Belanja Online',
    },
    description: {
      en: 'Verify if an online seller, buyer, or deal is legitimate.',
      id: 'Verifikasi apakah penjual online, pembeli, atau penawaran itu sah.',
    },
    questions: [
      {
        id: 'too_good_price',
        text: {
          en: 'Is the price significantly lower than market value (50% off or more)? If it seems too good to be true, it probably is.',
          id: 'Apakah harga jauh lebih rendah dari nilai pasar (diskon 50% atau lebih)? Jika tampaknya terlalu bagus untuk menjadi kenyataan, mungkin memang begitu.',
        },
        weight: 2,
      },
      {
        id: 'outside_platform',
        text: {
          en: 'Is the seller insisting on communicating or completing payment outside the official platform (via WhatsApp, direct bank transfer) to "avoid fees"?',
          id: 'Apakah penjual bersikeras berkomunikasi atau menyelesaikan pembayaran di luar platform resmi (melalui WhatsApp, transfer bank langsung) untuk "menghindari biaya"?',
        },
        weight: 3,
      },
      {
        id: 'payment_method',
        text: {
          en: 'Are they asking for payment via gift cards, cryptocurrency, Western Union, or "friends and family" transfer that offers no buyer protection?',
          id: 'Apakah mereka meminta pembayaran melalui kartu hadiah, cryptocurrency, Western Union, atau transfer "teman dan keluarga" yang tidak menawarkan perlindungan pembeli?',
        },
        weight: 3,
      },
      {
        id: 'no_reviews',
        text: {
          en: 'Does the seller have a new account with no reviews, only positive reviews posted on the same day, or reviews that seem fake/generic?',
          id: 'Apakah penjual memiliki akun baru tanpa ulasan, hanya ulasan positif yang diposting pada hari yang sama, atau ulasan yang tampak palsu/generik?',
        },
        weight: 2,
      },
      {
        id: 'pressure',
        text: {
          en: 'Are they pressuring you to buy immediately with phrases like "many others are interested", "last item", or "offer expires in 1 hour"?',
          id: 'Apakah mereka mendesak Anda untuk membeli segera dengan frasa seperti "banyak orang lain tertarik", "barang terakhir", atau "penawaran berakhir dalam 1 jam"?',
        },
        weight: 1,
      },
      {
        id: 'stock_photos',
        text: {
          en: 'Are the product photos clearly stock images, stolen from other listings, or do they refuse to provide additional real photos when asked?',
          id: 'Apakah foto produk jelas merupakan gambar stok, dicuri dari listing lain, atau apakah mereka menolak memberikan foto asli tambahan saat diminta?',
        },
        weight: 2,
      },
      {
        id: 'shipping_address',
        text: {
          en: 'Are they asking you to ship to a different address than what\'s on the order, or to a "forwarding service" address?',
          id: 'Apakah mereka meminta Anda mengirim ke alamat yang berbeda dari yang ada di pesanan, atau ke alamat "layanan penerusan"?',
        },
        weight: 2,
      },
      {
        id: 'overpayment',
        text: {
          en: 'If you\'re selling: Did the buyer "accidentally" overpay and ask you to refund the difference before the original payment clears?',
          id: 'Jika Anda menjual: Apakah pembeli "tidak sengaja" membayar lebih dan meminta Anda mengembalikan selisihnya sebelum pembayaran asli dikonfirmasi?',
        },
        weight: 3,
      },
      {
        id: 'fake_receipt',
        text: {
          en: "Did they send you a payment receipt or screenshot that looks suspicious, or claim they've paid but the money hasn't appeared in your account?",
          id: 'Apakah mereka mengirimkan bukti pembayaran atau screenshot yang terlihat mencurigakan, atau mengklaim sudah membayar tetapi uangnya belum muncul di akun Anda?',
        },
        weight: 2,
      },
      {
        id: 'no_return_policy',
        text: {
          en: 'Does the seller refuse to provide any return policy, warranty, or clear terms of sale? Are they vague about product specifications?',
          id: 'Apakah penjual menolak memberikan kebijakan pengembalian, garansi, atau syarat penjualan yang jelas? Apakah mereka tidak jelas tentang spesifikasi produk?',
        },
        weight: 1,
      },
    ],
  },
  {
    scamType: 'sextortion-blackmail',
    title: {
      en: 'Sextortion & Blackmail Risk Assessment',
      id: 'Penilaian Risiko Sextortion & Pemerasan',
    },
    description: {
      en: 'Check if you are being targeted by sextortion or blackmail.',
      id: 'Periksa apakah Anda menjadi target sextortion atau pemerasan.',
    },
    questions: [
      {
        id: 'threats',
        text: {
          en: 'Is someone threatening to share your intimate photos, videos, or private information with your contacts, employer, or publicly online?',
          id: 'Apakah seseorang mengancam akan membagikan foto intim, video, atau informasi pribadi Anda kepada kontak Anda, atasan, atau secara publik online?',
        },
        weight: 3,
      },
      {
        id: 'money_demand',
        text: {
          en: 'Are they demanding money (often in cryptocurrency or gift cards) to delete the content or keep it private?',
          id: 'Apakah mereka menuntut uang (sering dalam cryptocurrency atau kartu hadiah) untuk menghapus konten atau merahasiakannya?',
        },
        weight: 3,
      },
      {
        id: 'video_call',
        text: {
          en: 'Did someone record you during a video call (especially one that became sexual or intimate) without your knowledge or consent?',
          id: 'Apakah seseorang merekam Anda selama panggilan video (terutama yang menjadi seksual atau intim) tanpa sepengetahuan atau persetujuan Anda?',
        },
        weight: 3,
      },
      {
        id: 'countdown',
        text: {
          en: 'Is there a countdown timer, deadline, or ultimatum for payment? Are they saying things like "Pay within 24 hours or I\'ll send it to everyone"?',
          id: 'Apakah ada penghitung waktu mundur, tenggat waktu, atau ultimatum untuk pembayaran? Apakah mereka mengatakan hal seperti "Bayar dalam 24 jam atau saya akan mengirimkannya ke semua orang"?',
        },
        weight: 2,
      },
      {
        id: 'hacking_claim',
        text: {
          en: 'Do they claim to have hacked your device, webcam, or email and have recordings of you? (Note: These claims are often fake scare tactics)',
          id: 'Apakah mereka mengaku telah meretas perangkat, webcam, atau email Anda dan memiliki rekaman Anda? (Catatan: Klaim ini sering merupakan taktik menakut-nakuti palsu)',
        },
        weight: 2,
      },
      {
        id: 'escalating_demands',
        text: {
          en: "After you paid once, are they coming back asking for more money? Scammers often continue demanding more once they know you'll pay.",
          id: 'Setelah Anda membayar sekali, apakah mereka kembali meminta lebih banyak uang? Penipu sering terus menuntut lebih banyak setelah mereka tahu Anda akan membayar.',
        },
        weight: 3,
      },
      {
        id: 'contact_list',
        text: {
          en: "Are they showing you screenshots of your contact list, social media friends, or claiming they know your family/colleagues' information?",
          id: 'Apakah mereka menunjukkan screenshot daftar kontak Anda, teman media sosial, atau mengklaim mereka mengetahui informasi keluarga/kolega Anda?',
        },
        weight: 2,
      },
      {
        id: 'dating_app_origin',
        text: {
          en: 'Did this situation start from a dating app, social media, or random friend request from an attractive stranger who quickly became flirtatious?',
          id: 'Apakah situasi ini dimulai dari aplikasi kencan, media sosial, atau permintaan pertemanan acak dari orang asing menarik yang dengan cepat menjadi menggoda?',
        },
        weight: 2,
      },
      {
        id: 'password_email',
        text: {
          en: 'Did you receive an email containing one of your old passwords, claiming they have compromising videos of you from hacking your webcam?',
          id: 'Apakah Anda menerima email yang berisi salah satu kata sandi lama Anda, mengklaim mereka memiliki video kompromi Anda dari meretas webcam Anda?',
        },
        weight: 2,
      },
    ],
  },
  {
    scamType: 'job-scam',
    title: {
      en: 'Job Scam Assessment',
      id: 'Penilaian Penipuan Lowongan Kerja',
    },
    description: {
      en: 'Verify if a job offer is legitimate or a scam.',
      id: 'Verifikasi apakah tawaran pekerjaan itu sah atau penipuan.',
    },
    questions: [
      {
        id: 'upfront_payment',
        text: {
          en: 'Are you asked to pay for training materials, equipment, visa processing, background checks, or "registration fees" before starting work?',
          id: 'Apakah Anda diminta membayar materi pelatihan, peralatan, pemrosesan visa, pemeriksaan latar belakang, atau "biaya pendaftaran" sebelum mulai bekerja?',
        },
        weight: 3,
      },
      {
        id: 'high_salary',
        text: {
          en: 'Is the salary unusually high for the role, your experience level, or the amount of work required? Does it seem too easy for the pay offered?',
          id: 'Apakah gaji sangat tinggi untuk peran tersebut, tingkat pengalaman Anda, atau jumlah pekerjaan yang diperlukan? Apakah tampaknya terlalu mudah untuk gaji yang ditawarkan?',
        },
        weight: 2,
      },
      {
        id: 'chat_interview',
        text: {
          en: 'Was the entire "interview" conducted via text message, WhatsApp, or Telegram without any video call or in-person meeting?',
          id: 'Apakah seluruh "wawancara" dilakukan melalui pesan teks, WhatsApp, atau Telegram tanpa panggilan video atau pertemuan langsung?',
        },
        weight: 2,
      },
      {
        id: 'vague_details',
        text: {
          en: 'Are the job details, company information, or job responsibilities vague? Can you verify the company exists through independent research?',
          id: 'Apakah detail pekerjaan, informasi perusahaan, atau tanggung jawab pekerjaan tidak jelas? Bisakah Anda memverifikasi perusahaan ada melalui penelitian independen?',
        },
        weight: 2,
      },
      {
        id: 'personal_info',
        text: {
          en: 'Are they asking for sensitive personal info (bank details, ID copies, passport) very early in the process, before any formal offer letter?',
          id: 'Apakah mereka meminta info pribadi sensitif (detail bank, salinan ID, paspor) sangat awal dalam proses, sebelum surat penawaran formal?',
        },
        weight: 2,
      },
      {
        id: 'overseas_pressure',
        text: {
          en: 'Is the job overseas and are they pressuring you to travel immediately, offering to arrange everything (flights, accommodation, visa)?',
          id: 'Apakah pekerjaan di luar negeri dan mereka mendesak Anda untuk segera bepergian, menawarkan untuk mengatur semuanya (penerbangan, akomodasi, visa)?',
        },
        weight: 3,
      },
      {
        id: 'generic_email',
        text: {
          en: 'Is the recruiter using a free email address (Gmail, Yahoo, Hotmail) instead of an official company email domain?',
          id: 'Apakah perekrut menggunakan alamat email gratis (Gmail, Yahoo, Hotmail) alih-alih domain email perusahaan resmi?',
        },
        weight: 2,
      },
      {
        id: 'task_scam',
        text: {
          en: 'Does the "job" involve simple online tasks (liking videos, rating products, clicking links) with promises of easy daily income?',
          id: 'Apakah "pekerjaan" melibatkan tugas online sederhana (menyukai video, memberi rating produk, mengklik tautan) dengan janji penghasilan harian yang mudah?',
        },
        weight: 3,
      },
      {
        id: 'deposit_required',
        text: {
          en: 'After initial easy earnings, are they now asking you to "deposit" or "invest" money to unlock higher-paying tasks or withdraw your earnings?',
          id: 'Setelah penghasilan awal yang mudah, apakah mereka sekarang meminta Anda untuk "menyetor" atau "berinvestasi" uang untuk membuka tugas berbayar lebih tinggi atau menarik penghasilan Anda?',
        },
        weight: 3,
      },
      {
        id: 'reshipping',
        text: {
          en: 'Does the job involve receiving packages at home and reshipping them elsewhere? This could make you an unwitting participant in fraud.',
          id: 'Apakah pekerjaan melibatkan menerima paket di rumah dan mengirimkannya ke tempat lain? Ini bisa membuat Anda menjadi peserta tanpa sadar dalam penipuan.',
        },
        weight: 3,
      },
      {
        id: 'money_transfer',
        text: {
          en: 'Does the job involve receiving money into your bank account and transferring it elsewhere (minus your "commission")? This is money laundering.',
          id: 'Apakah pekerjaan melibatkan menerima uang ke rekening bank Anda dan mentransfernya ke tempat lain (dikurangi "komisi" Anda)? Ini adalah pencucian uang.',
        },
        weight: 3,
      },
    ],
  },
]
